import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CitadelErrorLoggingService } from '@citadel/core';
import { SignInService } from 'src/app/services/sign-in-service';

@Component({
    selector: 'app-sign-in-redirector',
    templateUrl: './sign-in-redirector.component.html',
    styleUrls: ['./sign-in-redirector.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SignInRedirectorComponent implements OnInit {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private errorLog = inject(CitadelErrorLoggingService);
  private signInService = inject(SignInService);
  private readonly signInContextKey = 'Citadel.Auth.Service.SignInContext';

  ngOnInit() {
    this.errorLog.logError('auth-redirect-debug', `SignInRedirector: with parameters: ${JSON.stringify(this.route.snapshot.queryParams)}`);
    const returnUrl = this.addAuthSegment(this.route.snapshot.queryParams['ReturnUrl'] || '');
    if (returnUrl) {
      this.storeSignInContext(returnUrl);
      this.errorLog.logError('auth-redirect-debug', `SignInRedirector: Navigating to sign-in with returnUrl: ${returnUrl}`);
      this.router.navigate(['..', 'sign-in'], { relativeTo: this.route, state: { 
        returnUrl,
        queryParams: {
          ReturnUrl: null,
        },
        queryParamsHandling: 'merge'
      }});
    } else {
      this.clearSignInContext();
      this.errorLog.logError('auth-redirect-debug', `SignInRedirector: No returnUrl found, navigating up one level`);
      this.router.navigate(['..'], { relativeTo: this.route });
    }
  }

  private storeSignInContext(returnUrl: string) {
    try {
      sessionStorage.setItem(this.signInContextKey, JSON.stringify({ returnUrl }));
    } catch {
    }
  }

  private clearSignInContext() {
    try {
      sessionStorage.removeItem(this.signInContextKey);
    } catch {
    }
  }

  private addAuthSegment(url: string) {
    // if (url.startsWith('/connect/authorize')) {
    //   return `/auth${url}`;
    // } else {
      return url;
    // }
  }
}
